import { contactData } from '@/mocks/home-data';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            {contactData.title}
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-10 text-center max-w-2xl mx-auto leading-relaxed">
          {contactData.desc}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactData.methods.map((method) => (
            <div
              key={method.label}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${method.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-800 mb-1.5">
                {method.label}
              </h3>
              <p className="text-xs text-foreground-500 font-mono break-all">
                {method.value}
              </p>
            </div>
          ))}
        </div>

        <p className="text-xs text-foreground-400 text-center mt-6">
          投稿即视为同意平台使用条款，我们将严格保护投稿人隐私
        </p>
      </div>
    </section>
  );
}